import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { actionSignIn, actionSignUp } from "../../api/postApi";
import { waitTime } from "../../utils/waitTime";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaMobileAlt } from "react-icons/fa";
import { RiUser3Fill, RiUserSmileFill } from "react-icons/ri";
import { BiKey, BiTransferAlt } from "react-icons/bi";
import GoogleLoginButton from "./components/googleLogin";
import TelegramLogin from "./components/telegramLogin";
import GoogleLoginV2 from "./components/GoogleLogin_v2";
import CreditPage from "../../utils/credit/credit_page";
import LineLogin from "./components/LineLogin";
import useTransCode from "../../hook/useTransCode";
import useInviteCode from "../../hook/useInviteCode";
import { COMMON_WEB_PATH } from "../../constant";
import CustomCheckbox from "./components/CustomCheckbox";
import i18next from "i18next";
import useGames from "../Game/useGames";

const iconStyle = "text-gray-300";

const SigninForm = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const toast = useToast();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { previousPage } = useGames();

  const [formData, setFormData] = useState({
    user_name: Cookies.get(`${process.env.REACT_APP_WEB_NAME}_account`) || "",
    password: Cookies.get(`${process.env.REACT_APP_WEB_NAME}_password`) || "",
    remember_account:
      Cookies.get(`${process.env.REACT_APP_WEB_NAME}_account`) || false,
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const trans_code = useTransCode();
  const invite_code = useInviteCode();

  const open_registration = window?.open_registration == 1;

  const { user_name, password, remember_account } = formData;

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChecked = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked,
    });
  };

  const handleSeePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonLoading(true);

    if (remember_account) {
      Cookies.set(`${process.env.REACT_APP_WEB_NAME}_account`, user_name, {
        expires: 3,
      });
      Cookies.set(`${process.env.REACT_APP_WEB_NAME}_password`, password, {
        expires: 3,
      });
    } else {
      Cookies.remove(`${process.env.REACT_APP_WEB_NAME}_account`);
      Cookies.remove(`${process.env.REACT_APP_WEB_NAME}_password`);
    }

    await actionSignIn({
      account: user_name,
      passwd: password,
      trans_code: trans_code,
    })
      .then((data) => {
        if (Cookies.get("token")) {
          Cookies.remove("token");
        }
        Cookies.set("token", data.token, { expires: 365 });
        Cookies.remove("trans_code");
        dispatch({
          type: "INITIALIZE_API",
          navigate: navigate,
        });

        navigate(previousPage);
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <form className="max-w-[350px]" onSubmit={handleSubmit}>
      <VStack spacing={`15px`}>
        <FormControl display={"flex"} gap="5px" isRequired>
          <Box>
            <Image
              minW="48px"
              minH="48px"
              maxW="48px"
              maxH="48px"
              src={`${COMMON_WEB_PATH}/now888/signIn/acc_icon.png`}
            />
          </Box>
          <InputGroup
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/now888/signIn/input_bg.png) !important`,
            }}
            w="100%"
            bgSize="100% 100%"
          >
            <Input
              type="text"
              name="user_name"
              bg="transparent"
              value={user_name}
              onChange={handleInputChange}
              placeholder={`${i18n_common("pleaseInput")} ${i18n_common_form(
                "account"
              )}`}
            />
          </InputGroup>
        </FormControl>
        <FormControl display={"flex"} gap="5px" isRequired>
          <Box>
            <Image
              minW="48px"
              minH="48px"
              maxW="48px"
              maxH="48px"
              src={`${COMMON_WEB_PATH}/now888/signIn/pwd_icon.png`}
            />
          </Box>
          <InputGroup
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/now888/signIn/input_bg.png) !important`,
            }}
            w="100%"
            bgSize="100% 100%"
          >
            <Input
              type={showPassword ? "text" : "password"}
              bg="transparent"
              name="password"
              value={password}
              onChange={handleInputChange}
              placeholder={`${i18n_common("pleaseInput")} ${i18n_common_form(
                "password"
              )}`}
            />

            <InputRightElement top="unset" bottom="0px">
              {showPassword ? (
                <FaEyeSlash
                  className="cursor-pointer"
                  onClick={handleSeePassword}
                />
              ) : (
                <FaEye className="cursor-pointer" onClick={handleSeePassword} />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        {trans_code && (
          <FormControl isRequired>
            <FormLabel>{i18n_common_form("轉移代碼")}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <BiTransferAlt className={iconStyle} />
              </InputLeftElement>
              <Input
                type={"text"}
                variant={`brandPrimary`}
                name="trans_code"
                value={trans_code}
                isDisabled={true}
              />
            </InputGroup>
          </FormControl>
        )}
        <Flex>
          <CustomCheckbox
            isChecked={remember_account}
            name="remember_account"
            onChange={handleChecked}
            style={{
              placeSelf: "flex-start",
            }}
            labelText={i18n_common("記住帳密")}
          />
        </Flex>
        <Flex direction="column" alignItems={"center"} gap="5px" w="100%">
          <Button
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/now888/button/confirm_background.png)`,
              bgSize: "contain",
              bgRepeat: "no-repeat",
              bgPosition: "center",
              background: "transparent",
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/now888/button/confirm_background.png)`,
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/now888/button/confirm_background.png)`,
              },
              h: "65px",
            }}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            py="20px"
            type="submit"
            w="130px"
          >
            <Image
              w="60%"
              src={`${COMMON_WEB_PATH}/now888/signIn/signIn_button_text${
                i18next.language == "tw" ? "" : `_${i18next.language}`
              }.png`}
            />
          </Button>
          {open_registration && (
            <Box
              sx={{
                bgImage: `url(${COMMON_WEB_PATH}/now888/button/cancel_background.png) !important`,
                bgSize: "contain !important",
                bgRepeat: "no-repeat !important",
                bgPosition: "center !important",
                background: "transparent",
                _hover: {
                  bgImage: `url(${COMMON_WEB_PATH}/now888/button/cancel_background.png)`,
                },
                _active: {
                  bgImage: `url(${COMMON_WEB_PATH}/now888/button/cancel_background.png)`,
                },
                h: "65px",
              }}
              isLoading={buttonLoading}
              disabled={buttonLoading}
              py="20px"
              as={Link}
              to="../signup"
              w="130px"
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Image
                w="50%"
                src={`${COMMON_WEB_PATH}/now888/signIn/signUp_button_text${
                  i18next.language == "tw" ? "" : `_${i18next.language}`
                }.png`}
              />
            </Box>
          )}
          {/* <GoogleLoginButton
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
          {/* <CreditPage>
            <GoogleLoginV2 />
            <TelegramLogin
              setButtonLoading={setButtonLoading}
              buttonLoading={buttonLoading}
            />
          </CreditPage> */}
          {/* <LineLogin
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
        </Flex>
      </VStack>
    </form>
  );
};

export default SigninForm;
